import React, { useState, useEffect } from 'react';
import CommonPaymentFailedIcon from "../../assets/img/CommonPaymentFailed.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import StorefrontTitle from "../shared/storefront-title.component";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import Storage from "../../services/storage.service";
import FirebaseAnalytics from '../../services/analytics.service';

const subscriptions = [];
const BillPaymentFailed = (props) => {

  const prefix = "scr_3.3.3";
  const appDownloadInfo = Translation.keys[prefix + "_app_download_info"];
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setLoader(true);
    FirebaseAnalytics.generic_event(16);
    // paymentErrorCode, paymentErrormsg
    const firePayInfo = Storage.get("firePayInfo", true);
    if(firePayInfo) {
      const firePayObj = JSON.parse(firePayInfo);
      if(firePayObj?.type === "bill_payment") {
        try {
          const findVat = () => {
            let vat_percentage = JSON.parse(Storage.get("business", true))[
              "vat_percentage"
            ] || 0;
            return vat_percentage;
          }
          let firebase_param = {
            payment_status: 0,
            amount: firePayObj?.amt,
            currency: Settings?.currency || "SR",
            tax: findVat() || 0,
            item_category: "bill"
          }
          FirebaseAnalytics.pay_bill(firebase_param)
        } catch (error) {
          // Do Nothing
        }
      }
    }

    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_error',
      interaction_type: 'view',
      event_label: 'payment_failed',
      error_code: Storage.get("paymentErrorCode", true) || ''
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);

    Storage.get_obsrv("paymentErrorCode").subscribe(data => {
      setErrorMsg(data);
    });

    setLoader(false);
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }

  }, []);

  const tryAgain = () => {
    setLoader(true);
    Storage.clear("calledFeatureConfirmation");
    Storage.clear("confirmSuccess");
    Storage.clear("confirmFailed");
    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_error',
      interaction_type: 'click',
      event_label: 'retry'
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);
    props.history.push({
      pathname: '/bill-payment/bills',
      state: { formValues: {
        phone: {
          value: Storage.get("billPaymentNumber", true)
        }
      }}
    });
  }

  const cancelProcess = () => {
    setLoader(true);
    localStorage.clear();
    const firebase_event_params = {
      event_category: 'bills',
      event_screen: 'bill_error',
      interaction_type: 'click',
      event_label: 'cancel'
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);
    setTimeout(() => {
      window.location.href = Settings.site_link;
    }, 1000);
  }

  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
        <div className="stm-topup-info-container bill-payment-success-failed">
          <div className="success-img">
            <img src={CommonPaymentFailedIcon} alt="" />
          </div>
          <div>
            <StorefrontTitle
              title={Translation.keys["stm_bill_payment_failed_heading"]}
              desc={Translation.keys["stm_bill_payment_failed_desc"]}
            />
            {errorMsg ?
            <p className="topup-error-msg">
              {Translation.keys["stm_general_failed_err_code"]}: {errorMsg}
            </p> : ""}
          </div>
          <div className="topup-field-wrapper">
            <div className="topup-btn-section">
              <button
                className="storefront-button"
                type="button"
                onClick={() => { tryAgain() }}
              >
                {Translation.keys[prefix + "_try_again"]}
              </button>
              <button
                className="common-button-light"
                type="button"
                onClick={() => { cancelProcess() }}
              >
                {Translation.keys["stf_cancel"]}
              </button>
            </div>
          </div>
          <DownloadApps
            info={appDownloadInfo}
            classes={"download-apps"}
            google_play_link={Settings.google_play_link}
            app_store_link={Settings.app_store_link}
            huawei_store_link={Settings.huawei_store_link}
          />
        </div>
      }
    </>
  );
};

export default BillPaymentFailed;